import { getApiKey } from "../../../utils/apiKey";
import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../../api";
import axios from "axios";
import Spinner from "../../Spinner/Spinner";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

export const ServicesCard = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  useEffect(() => {
    setLoading(true);
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    if (props.type === "active") {
      axios
        .get(`${apiCall_domain}/customer/mechanics/orders?status=active`, {
          headers,
        })
        .then((res) => {
          setData(res.data.data);
        })
        .finally(() => {
          setLoading(false);
        });
    } else
      axios
        .get(`${apiCall_domain}/customer/mechanics/orders?status=archived`, {
          headers,
        })
        .then((res) => {
          setData(res.data.data);
        })
        .finally(() => setLoading(false));
  }, [props]);

  return loading ? (
    <Spinner />
  ) : (
    <div className="serviceOrders">
      {data.map((item, q) => (
        <Link
          to={`/services/history/detail/${item.id}/${props.type}`}
          className="myOrder"
        >
          <div key={q} className="myOrderCard">
            <div className="myOrderHeader">
              <div className="myOrderTitle">
                <span>{item?.garage?.name || ""}</span>
                <span className="myOrderId">#{item?.id}</span>
              </div>
              <div
                className={`status ${
                  props.type === "active" ? "activeStatus" : "archiveStatus"
                }`}
              >
                <span>{item.status}</span>
              </div>
            </div>
            {/* <div className="serviceOrderServices">
            <i className="icon-cog" />
            <span></span>
          </div> */}
            <div className="serviceOrderAddress">
              <img src="/public/assets/services/service.svg" />

              <span>
                {item.type === "static"
                  ? "ثابت"
                  : item.type === "dynamic"
                    ? "سیار"
                    : "ثابت و سیار"}
              </span>
            </div>
            <div className="serviceOrderAddress">
              <img src="/public/assets/services/marker.svg" />
              <span>{item.address}</span>
            </div>
            <div className="serviceOrderTime">
              <img src="/public/assets/services/clock.svg" />
              <span>
                {item.time} - {item.requested_at}
              </span>
            </div>
            <div className="serviceOrderPrice">
              {/* <i className="icon-price-range" /> */}
              <img src="/public/assets/services/coinbag.svg" />
              {/* <span>هزینه : {item.final_price} تومان</span> */}
              <span>
                {item.final_price ? (
                  <>هزینه : {item.final_price} تومان</>
                ) : (
                  <>هزینه بعد از بررسی تعمیرکار مشخص میشود</>
                )}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};
